export function PageHeader({ title, sub, right }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-3 px-4 md:px-6 pt-4 md:pt-6 pb-3 border-b border-[var(--border)]">
      <div className="min-w-0">
        <h1 className="text-lg md:text-xl font-medium tracking-tight" data-testid="page-title">{title}</h1>
        {sub && <div className="text-xs text-neutral-500 mt-0.5">{sub}</div>}
      </div>
      {right && <div className="flex flex-wrap items-center gap-2">{right}</div>}
    </div>
  );
}

export function StatusDot({ status }) {
  const cls = {
    ok: "dot-ok", healthy: "dot-ok", configured: "dot-ok",
    warn: "dot-warn", stale: "dot-warn",
    breach: "dot-breach", error: "dot-breach", offline: "dot-breach",
    not_configured: "dot-off",
  }[status] || "dot-off";
  return <span className={`dot ${cls}`} data-testid={`status-${status}`} />;
}

export function StatusPill({ status, children }) {
  const cls = {
    ok: "pill-ok", healthy: "pill-ok", configured: "pill-ok",
    warn: "pill-warn", stale: "pill-warn",
    breach: "pill-breach", error: "pill-breach", offline: "pill-breach",
    not_configured: "",
  }[status] || "";
  return <span className={`pill ${cls}`}>{children || status || "—"}</span>;
}

export function Empty({ label = "No data yet", action, onAction, icon: Icon }) {
  return (
    <div className="p-8 text-center text-xs text-neutral-500 border border-dashed border-[var(--border)] rounded flex flex-col items-center gap-3" data-testid="empty-state">
      {Icon && <Icon size={20} className="text-neutral-600" />}
      <span>{label}</span>
      {action && <button className="btn text-xs" onClick={onAction} data-testid="empty-action-btn">{action}</button>}
    </div>
  );
}

export function Rows({ n = 6 }) {
  return (
    <div className="space-y-2" data-testid="loading-skeleton">
      {Array.from({ length: n }, (_, i) => <div key={i} className="h-9 rounded bg-[var(--panel-2)] animate-pulse" style={{ animationDelay: `${i * 80}ms` }} />)}
    </div>
  );
}
